import React from 'react'

import { Box } from "@mui/material"
import { AppRetailerBlock, AppValueChip } from "@components"
import { isMainRow } from "Pages/AnalyzersV2/@components/Table/@utils"


export default function websiteColumn(isBrokers, hideIcon = false, tagMainRow = false) {

	return {
		name: 'nameFilter',
		label: isBrokers ? "Providers" : 'Website',
		render: (value, row) => <Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
				gap: .5,
				width: 150,
				position: "sticky",
				top: 0,
				left: 0,
				zIndex: 3,
			}}>
			<AppRetailerBlock icon={hideIcon ? undefined : row.nameIcon} retailer={value} country={row.nameMarket}/>
			{tagMainRow && isMainRow(row) && <AppValueChip tone="accent" sx={{ py: 0.1, px: 0.75, fontSize: 10.5, fontWeight: 700 }}>
				you
			</AppValueChip>}
		</Box>,
	}
}